const API_ENDPOINT = 'PharmacyMessages';

export const API_PHARMACY_MESSAGE = {
  API_ENDPOINT,
  GET_ALL_DYNAMIC: `${API_ENDPOINT}/GetAllDynamic`,
  POST: `${API_ENDPOINT}/Create`,
  PATCH: (data: Pick<IPharmacyMessage, 'id'>) => `${API_ENDPOINT}/Patch/${data.id}`,
  DELETE: (data: Pick<IPharmacyMessage, 'id'>) => `${API_ENDPOINT}/Delete/${data.id}`,
};
export interface IPharmacyMessage extends Components.Schemas.PharmacyMessage {}
